export type Measurement =
  | 'Wind Speed'
  | 'Temperature'
  | 'Cloud Cover'
  | 'Precipitation'
  | 'Relative Humidity'
  | 'Barometric Pressure';

export type MeasurementWithExtras = Measurement | 'Wind Gust' | 'Dewpoint';

export const measurementList: Measurement[] = [
  'Wind Speed',
  'Temperature',
  'Cloud Cover',
  'Precipitation',
  'Relative Humidity',
  'Barometric Pressure',
];

export const measurementListWithExtras: MeasurementWithExtras[] = [
  'Temperature',
  'Wind Speed',
  'Wind Gust',
  'Cloud Cover',
  'Dewpoint',
  'Relative Humidity',
  'Precipitation',
  'Barometric Pressure',
];

export type MeasurementData =
  | 'wind_kph'
  | 'gust_kph'
  | 'temp_c'
  | 'cloud_percent'
  | 'precip_mm'
  | 'humidity'
  | 'dewpoint_c'
  | 'pressure_mb';

export type WeatherMap = {
  [K in Measurement]: {
    data: MeasurementData;
    unit: string;
  };
};

export const weatherMap: WeatherMap = {
  'Wind Speed': {
    data: 'wind_kph',
    unit: 'Kilometers / Hour',
  },
  Temperature: {
    data: 'temp_c',
    unit: 'Celcius',
  },
  'Cloud Cover': {
    data: 'cloud_percent',
    unit: 'Percent',
  },
  Precipitation: {
    data: 'precip_mm',
    unit: 'Millimeters',
  },
  'Relative Humidity': {
    data: 'humidity',
    unit: 'Percent',
  },
  'Barometric Pressure': {
    data: 'pressure_mb',
    unit: 'Millibars',
  },
};

export const weatherMapWithExtras = {
  ...weatherMap,
  'Wind Gust': { data: 'gust_kph', unit: 'Kilometers / Hour' },
  Dewpoint: { data: 'dewpoint_c', unit: 'Celcius' },
};

export type ReverseWeatherMap = {
  [K in MeasurementData]: MeasurementWithExtras;
};

export const reverseWeatherMapWithExtras: ReverseWeatherMap = {
  wind_kph: 'Wind Speed',
  temp_c: 'Temperature',
  cloud_percent: 'Cloud Cover',
  precip_mm: 'Precipitation',
  humidity: 'Relative Humidity',
  pressure_mb: 'Barometric Pressure',
  gust_kph: 'Wind Gust',
  dewpoint_c: 'Dewpoint',
};

export type WeatherAlertCurrentConditions = {
  [condition: string]: {
    warning: boolean;
    threshold: number | null | undefined;
    dishName: string;
  }[];
};
